export const withOpacity = (color: string, opacity?: number) =>
  `${color}${Math.floor(opacity ? opacity * 255 : 0.48 * 255).toString(16)}`;
